﻿import { Injectable } from '@angular/core';
import { Utils } from '../../../../../fork-common-controls/utils.service';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SessionStorageService {

  // Any new data to be saved, should define a key here and use with any
  // sessionStore setItem or getItem accordingly.
  public static COMMON_SESSION_DATA_KEY: string = 'CommonSessionData';
  public static PERSONAL_LOANS_SESSION_DATA_KEY: string = 'PersonalLoansSessionData';
  public static MORTGAGE_SESSION_DATA_KEY: string = 'MortgageSessionData';
  public static MORTGAGE_APPLICATION_PROGRESS_DATA_KEY: string = 'MortgageApplicationProgressData';
  public static PERSONAL_LOAN_APPLICATION_PROGRESS_DATA_KEY: string = 'PersonalLoanApplicationProgressData';
  public static onHydrateAfterSignIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  private static HYDRATED_WIZARD_STEPS_KEY: string = 'HydratedWizardSteps';

  public static get isAnyStepHydratable(): boolean {
    return (SessionStorageService.hydratedSteps || []).length > 0;
  }

  public static isMarkedForRefreshHydration(hydrationKey: string): boolean {
    return SessionStorageService.isStepHydratable(hydrationKey);
  }

  public static markAllStepsHydratable(steps: string[]): void {
    SessionStorageService.setItem(SessionStorageService.HYDRATED_WIZARD_STEPS_KEY, steps);
  }

  public static markForRefreshHydration(hydrationKey: string): void {
    const steps = SessionStorageService.hydratedSteps;
    const isStepAbsent = !SessionStorageService.isStepHydratable(hydrationKey);

    if (isStepAbsent) {
      steps.push(hydrationKey);
      SessionStorageService.setItem(SessionStorageService.HYDRATED_WIZARD_STEPS_KEY, steps);
    }
  }

  public static deleteHydrationKeys(): void {
    SessionStorageService.removeItem(SessionStorageService.HYDRATED_WIZARD_STEPS_KEY);
  }

  public static deleteMortgageApplicationProgressData(): void {
    SessionStorageService.removeItem(SessionStorageService.MORTGAGE_APPLICATION_PROGRESS_DATA_KEY);
  }

  public static deletePersonalLoanApplicationProgressData(): void {
    SessionStorageService.removeItem(SessionStorageService.PERSONAL_LOAN_APPLICATION_PROGRESS_DATA_KEY);
  }

  public static savePersonalLoanApplicationProgressData(
    hasRegistered: boolean,
    hasSelectedOffer: boolean,
    hasApplied: boolean
  ): void {

    const model = {
      hasRegistered,
      hasSelectedOffer,
      hasApplied
    };

    SessionStorageService.setItem(SessionStorageService.PERSONAL_LOAN_APPLICATION_PROGRESS_DATA_KEY, model);
  }

  public static getMortgageApplicationProgressData(): any {
    return SessionStorageService.getItem(SessionStorageService.MORTGAGE_APPLICATION_PROGRESS_DATA_KEY);
  }

  public static getPersonalLoanApplicationProgressData(): any {
    return SessionStorageService.getItem(SessionStorageService.PERSONAL_LOAN_APPLICATION_PROGRESS_DATA_KEY);
  }

  private static get hydratedSteps(): string[] {
    const hydratedSteps = SessionStorageService.getItem(SessionStorageService.HYDRATED_WIZARD_STEPS_KEY);
    return hydratedSteps || [];
  }

  private static isStepHydratable(hydrationKey: string): boolean {
    const steps = SessionStorageService.hydratedSteps;
    const isStepPresent = steps.indexOf(hydrationKey) >= 0;
    return isStepPresent;
  }

  private static removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  private static getItem(key: string) {
    const item = localStorage.getItem(key);
    return typeof item === 'object'
      ? item
      : JSON.parse(item);
  }

  private static setItem(key: string, value: any): void {
    localStorage.setItem(key, (value ? Utils.JSONStringify(value) : ''));
  }

  public getItem(key): any {
    const item = localStorage.getItem(key);
    return typeof item === 'object'
      ? item
      : JSON.parse(item);
  }

  public removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  public setItem(key: string, value: any): void {
    localStorage.setItem(key, value ? Utils.JSONStringify(value) : '');
  }
}
